import Link from "next/link";
import type { CtaButton } from "@/lib/storefront-types";

type BlockCtaButtonsProps = {
  buttons: CtaButton[];
  className?: string;
};

const toneStyles: Record<CtaButton["style"], string> = {
  primary:
    "storefront-bg-primary text-white shadow-[0_20px_36px_-18px_rgba(0,39,0,0.58)] hover-storefront-bg-primary-dark",
  secondary:
    "border storefront-border-soft bg-white storefront-text-heading hover:bg-[var(--storefront-primary)] hover:text-white hover:border-transparent",
  ghost:
    "border border-white/22 bg-white/8 text-white backdrop-blur-sm hover:bg-white hover:text-[#002700] hover:border-white",
};

export function BlockCtaButtons({ buttons, className = "" }: BlockCtaButtonsProps) {
  const enabled = buttons.filter((button) => button.enabled);

  if (enabled.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      {enabled.map((button) => (
        <Link
          key={button.label}
          href={button.href}
          target={button.target === "blank" ? "_blank" : undefined}
          rel={button.target === "blank" ? "noopener noreferrer" : undefined}
          className={`inline-flex items-center justify-center rounded-full px-6 py-3.5 text-sm font-semibold transition-all duration-200 hover:-translate-y-px hover:shadow-lg ${toneStyles[button.style]}`}
        >
          {button.label}
        </Link>
      ))}
    </div>
  );
}
